'use client'

import { useTheme } from '@/contexts/ThemeContext'

export default function TermsPage() {
  const { theme } = useTheme()

  return (
    <div className={`min-h-screen py-12 px-4 ${
      theme === 'light'
        ? 'bg-gradient-to-br from-white via-blue-50 to-cyan-50'
        : 'bg-gray-900'
    }`}>
      <div className="max-w-4xl mx-auto">
        <h1 className={`text-3xl xxs:text-xl font-bold mb-8 xxs:mb-4 ${
          theme === 'light' ? 'text-gray-800' : 'text-white'
        }`}>이용약관</h1>

        <div className={`rounded-lg p-8 xxs:p-4 space-y-6 xxs:space-y-4 ${
          theme === 'light'
            ? 'bg-white shadow-lg text-gray-700'
            : 'bg-gray-800 text-gray-300'
        }`}>
          <section>
            <h2 className={`text-xl xxs:text-lg font-semibold mb-3 ${
              theme === 'light' ? 'text-gray-800' : 'text-white'
            }`}>제1조 (목적)</h2>
            <p>본 약관은 오늘다이빙(이하 "서비스")가 제공하는 프리다이빙 버디 매칭 서비스의 이용과 관련하여 서비스와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>
          </section>

          <section>
            <h2 className={`text-xl xxs:text-lg font-semibold mb-3 ${
              theme === 'light' ? 'text-gray-800' : 'text-white'
            }`}>제2조 (서비스의 제공)</h2>
            <p>서비스는 다음과 같은 서비스를 제공합니다:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>프리다이빙 버디 매칭</li>
              <li>다이빙 일정 관리</li>
              <li>자격증 인증 서비스</li>
            </ul>
          </section>

          <section>
            <h2 className={`text-xl xxs:text-lg font-semibold mb-3 ${
              theme === 'light' ? 'text-gray-800' : 'text-white'
            }`}>제3조 (회원가입)</h2>
            <p>회원가입은 카카오 계정을 통해 진행되며, 서비스가 정한 가입 양식에 따라 회원정보를 기입하여야 합니다.</p>
          </section>

          <section>
            <h2 className={`text-xl xxs:text-lg font-semibold mb-3 ${
              theme === 'light' ? 'text-gray-800' : 'text-white'
            }`}>제4조 (서비스 이용)</h2>
            <ul className="list-disc list-inside space-y-1">
              <li>서비스 이용시 타인의 권리를 침해하거나 불쾌감을 주는 행위를 해서는 안됩니다</li>
              <li>허위 정보를 기재하거나 타인의 정보를 도용해서는 안됩니다</li>
              <li>서비스를 상업적 목적으로 이용할 수 없습니다</li>
            </ul>
          </section>

          <section>
            <h2 className={`text-xl xxs:text-lg font-semibold mb-3 ${
              theme === 'light' ? 'text-gray-800' : 'text-white'
            }`}>제5조 (책임제한)</h2>
            <p>서비스는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</p>
          </section>

          <section>
            <h2 className={`text-xl xxs:text-lg font-semibold mb-3 ${
              theme === 'light' ? 'text-gray-800' : 'text-white'
            }`}>제6조 (분쟁해결)</h2>
            <p>본 약관은 대한민국 법령에 의하여 규정되고 이행되며, 서비스 이용과 관련하여 발생한 분쟁에 대해서는 민사소송법상의 주소지를 관할하는 법원을 합의관할로 합니다.</p>
          </section>

          <section className={`pt-4 border-t ${
            theme === 'light' ? 'border-gray-200' : 'border-gray-700'
          }`}>
            <p className={`text-sm ${
              theme === 'light' ? 'text-gray-500' : 'text-gray-400'
            }`}>시행일: 2025년 12월 1일</p>
          </section>
        </div>
      </div>
    </div>
  )
}